import { render, staticRenderFns } from "./courseDetails.html?vue&type=template&id=e53bf8e2&scoped=true&external"
import script from "./courseDetails.vue?vue&type=script&lang=ts"
export * from "./courseDetails.vue?vue&type=script&lang=ts"
import style0 from "./courseDetails.scss?vue&type=style&index=0&id=e53bf8e2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53bf8e2",
  null
  
)

export default component.exports